import { render, staticRenderFns } from "./Pagina.vue?vue&type=template&id=26b24d55"
import script from "./Pagina.vue?vue&type=script&lang=js"
export * from "./Pagina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports